(function() {
  function initFourCSlider() {
    const sliderSections = document.querySelectorAll('.four-c-section');
    
    sliderSections.forEach((section) => {
      const sliderImages = section.querySelector('.four-c-slider-images');
      const imageItems = sliderImages?.querySelectorAll('.four-c-slider-image-item');
      const sliderInput = section.querySelector('.four-c-range');
      
      if (!sliderInput || !imageItems || imageItems.length === 0) {
        return;
      }

      const updateSlider = (value) => {
        const index = parseInt(value);
        if (isNaN(index)) return;

        imageItems.forEach((item, i) => {
          if (i === index) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      };

      // 初期状態の設定
      updateSlider(sliderInput.value);

      // スライダーの変更イベント
      sliderInput.addEventListener('input', function() {
        updateSlider(this.value);
      });
    });
  }

  // DOMContentLoadedまたは既に読み込み済みの場合
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFourCSlider);
  } else {
    initFourCSlider();
  }
})();
